import api from '../api/client';

const grant = async (payload) => {
    const res = await api.post('/api/delegation/grant', payload);
    return res?.data;
};

const revoke = async (delegationId) => {
    const res = await api.post('/api/delegation/revoke', {
        delegation_id: delegationId,
    });
    return res?.data;
};

const getMyDelegations = async (appId) => {
    const res = await api.get('/api/delegation/my-delegations', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const getDelegatedToMe = async (appId) => {
    const res = await api.get('/api/delegation/delegated-to-me', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const getAll = async (appId, params = {}) => {
    const res = await api.get('/api/delegation/all', {
        params: { app_id: appId, ...params },
    });
    return res?.data?.data;
};

const update = async (payload) => {
    const res = await api.post('/api/delegation/update', payload);
    return res?.data;
};

const delegationsService = {
    grant,
    revoke,
    getMyDelegations,
    getDelegatedToMe,
    getAll,
    update,
};

export default delegationsService;
